let BASE_URL = "";
let SITO_URL = "";
let SERVIZI_URL = "";
let AGENDA_URL = "";
let LAYOUT_URL = "";

export const loadConfig = async () => {
  try {
    const response = await fetch("./config.json");
    const config = await response.json();
    BASE_URL = config.BASE_URL;
    SITO_URL = config.SITO_URL;
    SERVIZI_URL = config.SERVIZI_URL;
    AGENDA_URL = config.AGENDA_URL;
    LAYOUT_URL = config.LAYOUT_URL;
    console.log("Config loaded:", config);
  } catch (err) {
    console.error("Failed to load config.json", err);
  }
};

export { BASE_URL, SITO_URL, SERVIZI_URL, AGENDA_URL, LAYOUT_URL };
